import { cartViewURL } from '../../common/others/Configuration';
import rejectNonOkResponse from '../rejectNonOkResponse';

export default async () => {
  const response = await rejectNonOkResponse(
    fetch(cartViewURL, {
      // headers: {
      //   'x-requested-with': 'XMLHttpRequest',
      // },
      mode: 'cors',
      credentials: 'include',
    })
  );

  return response.text();
};
